import { render } from "./FreightSettingsView.vue?vue&type=template&id=0f319619"
import script from "./FreightSettingsView.vue?vue&type=script&lang=js"
export * from "./FreightSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__